<template>
  <div class="home-content-page-v prediction-source-page">
    <div class="content-1">
      <div class="gu-duan">
        <el-select v-model="oilSourceStation" filterable placeholder="请选择加油站">
          <el-option v-for="item in oilSourceStations" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
        <a href="javascript:;" class="btm-btn" v-if="errorPreData.length > 0" @click="dialogVisible = true">
          错误数据调整
        </a>
      </div>
      <div class="content-1-table-1 mii-table">
        <content-title title="进销存数据"></content-title>
        <table style="width: 100%;background: #fff;">
          <thead>
            <tr>
              <th>加油站</th>
              <th>油品类型</th>
              <th>时间</th>
              <th>期初库存(L)</th>
              <th>入库升数(L)</th>
              <th>出库升数(L)</th>
              <th>期末库存(L)</th>
              <th>空容(L)</th>
              <th>损溢(L)</th>
              <th>平均销量(L)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in showData">
              <td :rowspan="value.rowspan || 1" v-for="value in data" :class="{'data-td': !value.label, 's-bak-td': !value.label && (index % 3 === 1)}" v-if="value.rowspan !== 0">{{value.label || (String(value).slice(0, 9))}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div style="display: none">
      {{PreSourceData}}{{errorPreData}}
    </div>
    <el-dialog title="错误数据调整" :visible.sync="dialogVisible" size="large" :before-close="handleClose">
      <div class="content-1-table-1 mii-table">
        <table style="width: 100%;background: #fff;">
          <thead>
            <tr>
              <th>加油站</th>
              <th>油品类型</th>
              <th>时间</th>
              <th>期初库存(L)</th>
              <th>入库升数(L)</th>
              <th>出库升数(L)</th>
              <th>期末库存(L)</th>
              <th>损溢(L)</th>
              <th>平均销量(L)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index1) in errorPreData">
              <td v-for="(value, index) in data" :class="{'data-td': !value.label, 's-bak-td': !value.label && (index1 % 2 === 1), 'edit-td': [0, 1, 2, 9].indexOf(index) === -1, 'edit-td-error': !checkData(data) && [0, 1, 2, 9].indexOf(index) === -1, 'edit-td-success': checkData(data) && [0, 1, 2, 9].indexOf(index) === -1}" v-if="index !== 7">
                <span>{{value.label || (String(value).slice(0, 9))}}</span>
                <input v-if="[0, 1, 2, 9].indexOf(index) === -1" @focus="focusEdit(data, index)" type="text" class="edit-error-num" v-model="edit_data" v-on:blur="blur(data, index)">
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ContentTitle from '../components_bit/ContentTitle'

export default {
  name: 'cars',
  data () {
    return {
      edit_data: '',
      dialogVisible: false
    }
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
    },
    checkData (data) {
      return (Number(data[3]) + Number(data[4]) - Number(data[5]) - Number(data[6]) + Number(data[8])) === 0
    },
    sure () {
      this.dialogVisible = false
      this.$store.dispatch('updateCheckData')
    },
    focusEdit (data, index) {
      let num = Number(data[3]) + Number(data[4]) - Number(data[5]) - Number(data[6]) + Number(data[8])
      let lastNum = 0
      if ([3, 4, 8].indexOf(index) > -1) {
        lastNum = -(num - data[index])
      } else {
        lastNum = num + data[index]
      }
      this.edit_data = (index === 8) ? lastNum : (lastNum > 0 ? lastNum : 0)
    },
    blur (data, index) {
      this.$store.dispatch('editPreSourceData', {data, index, value: this.edit_data})
      this.edit_data = ''
    }
  },
  components: {
    ContentTitle
  },
  computed: {
    showData: {
      get () {
        let data = []
        if (this.PreSourceData) {
          let vm = this
          this.PreSourceData.forEach(function (item) {
            if (item.oil === vm.oilSourceStation) {
              data = item.data
            }
          })
          if (data[0] && data[0][0] && data[0][0].label) {
            return data
          }
          let row1 = {}
          let row2 = {}
          data.forEach(function (item, index) {
            let data1 = item[0]
            if (!row1[data1]) {
              row1[data1] = {index: index, data: {label: data1, rowspan: 1}}
            } else {
              row1[data1].data.rowspan ++
              item[0] = {label: data1, rowspan: 0}
            }
            let data2 = item[1]
            if (!row2[data2]) {
              row2[data2] = {index: index, data: {label: data2, rowspan: 1}}
            } else {
              row2[data2].data.rowspan ++
              item[1] = {label: data2, rowspan: 0}
            }
          })
          for (let key in row1) {
            data[row1[key].index][0] = row1[key].data
          }
          for (let key in row2) {
            data[row2[key].index][1] = row2[key].data
          }
        }
        return data
      }
    },
    PreSourceData: {
      get () {
        return this.$store.getters.PreSourceData
      }
    },
    preStatus: {
      get () {
        return this.$store.getters.preStatus
      }
    },
    errorPreData: {
      get () {
        let data = this.$store.getters.errorPreData
        return data
      }
    },
    oilSourceStation: {
      get () {
        return this.$store.getters.oilSourceStation
      },
      set (value) {
        return this.$store.dispatch('setOilSourceStation', value)
      }
    },
    oilSourceStations: {
      get () {
        return this.$store.getters.oilSourceStations
      }
    }
  },
  created () {
    if (this.preStatus === 0) {
      this.$store.dispatch('loadPreSourceData')
      this.$store.dispatch('loadLocationData')
    }
  }
}
</script>

<style scoped lang="less">
@import '../style/base.less';
.edit-td:hover {
  input {
    display: block;
  }
  span {
    display: none;
  }
}
.btm-btn {
  border-radius: 0.5rem;
  background-color: #f7bd34;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20rem;
  letter-spacing: 0.1rem;
  color: #fff;
}
.edit-td-error {
  color:  #f7bd34 !important;
}
.edit-td-success {
  color: #14cf65 !important;
}
.edit-td {
  text-align: center;
  input {
    margin: 0 auto;
    text-align: center;
    display: none;
  }
  span {
    display: block;
  }
}
.edit-error-num {
  width: 5rem;
}
.home-content-page-v {
  height: 55em;
}

.content-1-table-1 {
}
.gu-duan {
  margin-bottom:0.7em;
  width: 100%;
  .el-select {
    width: 25em;
  }
  display: flex;
  justify-content: space-between;
}
.content-1 {
  border-radius: 0.5em;
  padding: 0.88em 0.7em 2.25em;
  background-color: #e5e5e5;
  display: flex;
  flex-direction:column;
}
.content-1-tables {
  display: flex;
}
.mii-table-1 {
  background-color: @bak-color-td-2;
}
.mii-table {
  .content-shadow;
  .content-top-radius;
  display: flex;
  flex-direction:column;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.3);
  .data-td {
    width: 10%;
  }
  .s-bak-td {
    background-color: #e0e6ea;
    border:0 solid @bak-color-main;
  }
  .jj-bak-td {
    background-color: @bak-color-2;
    color: #00ccff;
  }
  .ps-bak-td {
    background-color: #98aab9;
  }
  table {
    border-spacing: 0px;
    width: 100%;
    th {
      border:0.2px solid @bak-color-main;
      text-align: center;
      font-size: 0.8em;
      line-height: 2.5em;
      color: @bak-color-1;
      font-weight: 100;
    }
    td {
      border:0.2px solid @bak-color-main;
      text-align: center;
      font-size: 0.8em;
      line-height: 2.5em;
      color: @bak-color-1;
    }
  }
}
</style>

<style lang="less">
.prediction-source-page {
  .el-scrollbar__wrap {
    overflow:visible;
  }
  .el-scrollbar {
    overflow:visible;
  }
  .el-select-dropdown {
    overflow: scroll
  }
  .gu-duan .el-input__icon+.el-input__inner {
    padding-left: 2.3em;
  }
  .gu-duan .el-select .el-input .el-input__icon {
    background: #081633;
    color: #fff;
    width: 5em;
    transition: none;
  }
  .gu-duan .el-input__icon+.el-input__inner {
    padding-left: 2.3em;
  }
}
</style>



// WEBPACK FOOTER //
// source_data_pre.vue?755c1176